<template>
  <div class="card red">
    <h2 class="card-h2"><span>Severities</span></h2>
    
    <div class="card-content fetch" v-bind:class="[{'is-loading': isLoading}]">
      <div v-if="hasResults">
        <table class="red">
          <thead>
            <tr>
              <th>Severity</th>
              <th>Rank</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ranking, index) in rankings" v-if="ranking !== null">
              <td>{{ labels[index].plural }}</td>
              <td>
                <span v-if="index !== 'fatalities'">{{ ranking.rank }}{{ ranking.rank === 1 ? 'st' : '' }}{{ ranking.rank === 2 ? 'nd' : '' }}{{ ranking.rank === 3 ? 'rd' : '' }}{{ ranking.rank > 3 ? 'th' : '' }}</span>
                <span v-else>n/a</span>
              </td>
              <td>{{ Number(ranking.amount).toLocaleString('en-US') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>No results that match those filters.</p>
      </div>
    </div>
    <div class="loader-dots-wrap center" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
  </div>
</template>

<script>
import LoaderDots from '@/components/LoaderDots'

let labels = {
  fatalities: {
    plural: 'Collisions with fatalities'
  },
  injuries: {
    plural: 'Collisions with injuries'
  },
  propertydamage: {
    plural: 'Property damage only collisions'
  },
  possibleinjury: {
    plural: 'Collisions with possible injuries'
  },
  seriousinjuries: {
    plural: 'Collisions with serious injuries'
  }
}

export default {
  name: 'severityRank',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  components: {
    'LoaderDots': LoaderDots
  },

  data: function () {
    return {
      labels: labels
    }
  },

  computed: {
    hasResults () {
      return (this.rankings[0] === -1) ? 0 : 1
    },

    isLoading () {
      return (Object.keys(this.rankings).length === 0) ? 1 : 0
    },

    rankings () {
      return this.$store.getters[this.getters.rankings]
    }
  }
}
</script>



// WEBPACK FOOTER //
// SeverityRank.vue?42713a67